/* eslint-disable */
import { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import styles from './GRNsPage.module.scss';
import { analyticsAction, formActions, modalActions } from '../../Actions';
import { notificationServices } from '../../Services';
import inventoryAnalyticsServices from '../../Services/Analytics Services/inventory-analytics.services';
import { POItemsModal } from '../../Components/Modals/POItemsModal';
import { useAuth } from '../../Components/Auth/Login/auth';
import { urls } from '../../Constants';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import authActions from '@/Actions/auth.actions';
import Tab from '@/Components/InfoTab/tab';
import SearchBar from '@/Components/SearchBar/SearchBar';
import Calender from '@/Components/Forms/Payment Settlements/Calender/Calender';
import { Chip, IconButton, Tooltip } from '@mui/material';
import { CheckPicker, SelectPicker } from 'rsuite';
import {
	convertWeightUnit,
	filtersInfoChip,
	formatDate, formatDateOneLiner, handleResponseStreamDownload, truncateText,
	useProductData,
	useQuery,
	useSearch,
} from '@/Helpers';
import excel from '@/Images/excel.svg';
import { ArrowCircleRight } from '@mui/icons-material';
import GrnTable from './GrnTable';
import { grnQcLogService } from '@/Services/grnQcLog.services';
import GlobalSearch from '@/Components/globalSearch/search';
import { Button } from '@/Components/ui/button';
import { Calculator, Filter } from 'lucide-react';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import drawerActions from '@/Actions/drawer.actions';
import wastageAction from '@/Actions/wastage.action';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import orderAnalyticsServices from '@/Services/Analytics Services/orderAnalytics.services';

const SPECIAL_COLUMNS = [
	{
		title: 'Grn Number',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vendor Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Grn Closed At',
		config: {
			type: 'DATA',
		},
	},
	// {
	// 	title: 'GRN Start Time',
	// 	config: {
	// 		type: 'DATA',
	// 	},
	// },
	{
		title: 'Po Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'order Completion',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Grn Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Bill Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'View Docs',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	'Grn Number': 'clientTransactionId',
	'Vendor Name': 'vendorName',
	'Grn Closed At': 'closedAt',
	// 'GRN Start Time': 'createdAt',
	'Po Id': 'clientPoId',
	'order Completion': 'id',
	'Grn Status': 'id',
	'Bill Status': 'id',
	'View Docs': 'id',
};

const aiMachineColMap = {
	Category: 'id',
	'Sub Category': 'id',
	'Sku Code': 'id',
	Store: 'storeName',
	'QC Time': 'QCTime',
	Result: 'result',
	'QR ID': 'OrderId',
	'Product Name': 'ProductName',
	'Net Quantity': 'id',
	'Temp': 'Temp',
	'Vendor Name': 'vendorName',
};

const aiMachineSpecialColumns = [
	{
		title: 'Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'QC Time',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'QR ID',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Product Name',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sku Code',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vendor Name',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Net Quantity',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Temp',
		config: {
			type: 'Data',
		},
	},
	{
		title: 'Result',
		config: {
			type: 'Data',
		},
	},
];

const tabList = [
	{
		value: 'grnLogs',
		label: 'GRN Logs',
	},
	{
		value: 'aiMachineLogs',
		label: 'AI Supervisor GRN Scans',
	},
];

const exportInfo = {
	showExportBtn: true,
};
const dropDownItems = [
	{
		label: 'PO ID',
		value: 'clientPoId',
	},
	{
		label: 'Vendor',
		value: 'vendorName',
	},
	{
		label: 'GRN Number',
		value: 'clientTransactionId',
	},
];

function GRNsPage({ navState }) {
	const history = useHistory();
	const location = useLocation();
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const navRequisites = navState?.[urls.PURCHASE_ORDERS]?.requisites ?? [];
	const navSelectedStore = navRequisites?.find((ele) => {
		return ele?.type === 'store';
	});
	const [search, setSearch] = useState({});
	const [activeTab, setActiveTab] = useState('grnLogs');
	const [filters, setFilters] = useState({});
	const queryParams = useQuery();
	const orderType = JSON.parse(queryParams?.get('orderType'));
	const products = useSelector((state) => state.form.ALL_PRODUCTS.data.LIST);
	const grnList = useSelector((state) => state.wastage.grnList);
	const aiGrnList = useSelector(
		(state) => state.analytics.QUALITY_ANALYTICS.SEARCH_DATA.list
	);
	const dispatch = useDispatch();

	useEffect(() => {
		// if (Array.isArray(products) && products?.length === 0) {
		useProductData(dispatch);
		// }
	}, []);

	useEffect(() => {
		if (!orderType || orderType === 'capex') {
			setActiveTab('grnLogs');
		} else if (orderType === 'aiMachineLogs') {
			setActiveTab(orderType);
		} else {
			setActiveTab(orderType);
		}
	}, []);

	const getStatusColor = (status) => {
		switch ((status || '').toUpperCase()) {
			case 'PASSED':
				return 'bg-green-100 text-green-700';
				break;
			case 'FAILED':
				return 'bg-red-100 text-red-700';
				break;
			case 'PENDING':
				return 'bg-orange-100 text-orange-700';
				break;
			default:
				return '';
		}
	};

	const aiMachineSpecialColumnsMappings = {
		Store: (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>{items}</div>
			);
		},
		'QC Time': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>{items}</div>
			);
		},
		'QR ID': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>{items}</div>
			);
		},
		'Product Name': (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>{items}</div>
			);
		},
		Category: (id, items) => {
			const item = aiGrnList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{
						products?.find(
							(product) =>
								Number(product?.id) === Number(item?.productId)
						)?.categoryName
					}
				</div>
			);
		},
		'Sub Category': (id, items) => {
			const item = aiGrnList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{
						products?.find(
							(product) =>
								Number(product?.id) === Number(item?.productId)
						)?.subCategoryName
					}
				</div>
			);
		},
		'Sku Code': (id, items) => {
			const item = aiGrnList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{
						products
							?.find(
								(product) =>
									Number(product?.id) ===
									Number(item?.productId)
							)
							?.variants?.find(
								(variant) =>
									Number(variant?.id) ===
									Number(item?.variantId)
							)?.clientVariantId
					}
				</div>
			);
		},
		'Vendor Name': (id, items) => {
			return (
				<div
					className='text-left text-[12px] text-nowrap'
					title={items}
				>
					{truncateText(items)}
				</div>
			);
		},
		'Net Quantity': (id, items) => {
			const obj = aiGrnList?.find((ele) => {
				return ele?.id === id;
			});
			const quantity = obj?.unit !== 'count' ? obj?.Weight : obj?.count;
			return (
				<div className='text-left text-[12px] text-nowrap'>
					{convertWeightUnit(quantity, obj?.unit, undefined, true) ??
						'-'}
				</div>
			);
		},
		Temp: (id, items) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>{items}</div>
			);
		},
		Result: (id, items) => {
			return (
				<div
					className={`w-[10rem] min-h-[2rem] text-[12px] flex flex-col items-center justify-center rounded-[4px] font-semibold ${getStatusColor(
						items
					)}`}
				>
					{items}
				</div>
			);
		},
	};

	const generateData = () => {
		const data = activeTab === 'grnLogs' ? grnList : aiGrnList;
		const filteredData = data?.filter((obj) => {
			if (search?.value === 'vendorName') {
				return obj[search?.value]
					?.toLowerCase()
					?.includes(search?.searchValue?.toLowerCase());
			} else if (search?.value === 'clientPoId') {
				return obj[search?.value]
					?.toLowerCase()
					?.includes(search?.searchValue?.toLowerCase());
			} else if (search?.value === 'clientTransactionId') {
				return obj[search?.value]
					?.toLowerCase()
					?.includes(search?.searchValue?.toLowerCase());
			}
			return true;
		});
		return filteredData;
	};

	const handleGrnListFetch = async (filters) => {
		try {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: 'loading...',
			});
			const responseData =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req: {
						data: {
							filters: {
								fromStoreId:
									Number(navSelectedStore?.value?.id) === -999
										? null
										: navSelectedStore?.value?.id,
								vendors: filters?.vendors?.id,
								storeId: filters?.store?.id,
								dateRangeFilter: {
									from: formatDate(
										filters?.dateRange?.from ?? new Date()
									),
									to: formatDate(
										filters?.dateRange?.to ?? new Date()
									),
									timeType: 'closedAt',
								},
								productId: filters?.product?.id ?? null,
								productCategoryId:
									filters?.productCategory?.id ?? null,
								grnStatus: filters?.type,
								billStatus: filters?.paymentType,

							},
							type: 'GRN',
							children: true,
							allowAbandoned: true,
						},
					},
				});
			if (responseData?.statusCode === 200) {
				dispatch(wastageAction.grnList(responseData?.data));
				notificationServices.generateNotification({
					type: 'success',
					message: 'Data fetch SucessFully',
					config: {
						id: notificationId,
					},
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handleAiMachineFetch = async (filters) => {
		const req = {
			data: {
				storeId: filters?.store?.id,
				vendors: filters?.vendors?.id,
				dateRangeFilter: {
					from: formatDate(filters?.dateRange?.from ?? formatDate(new Date())),
					to: formatDate(filters?.dateRange?.to ?? formatDate(new Date())),
				},
				productId: filters?.product?.id ?? null,
				productCategoryId: filters?.productCategory?.id ?? null,
				status: filters?.type,
				qcType: 'INWARD',
				onlyMachineScans: true,
			},
		}
		try {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: 'loading...',
			});
			const res = await grnQcLogService.fetchAiSupervisorScans(req);
			if (res?.statusCode === 200) {
				dispatch(analyticsAction.setAiQualityListScan(res?.data));
				notificationServices.generateNotification({
					type: 'success',
					message: 'Data fetch SucessFully',
					config: {
						id: notificationId,
					},
				});
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handleListFetch = (filters) => {
		setFilters(filters);
		setActiveTab(filters?.orderType || 'grnLogs');
		if (filters?.orderType === 'grnLogs') {
			handleGrnListFetch(filters);
		} else if (filters?.orderType === 'aiMachineLogs') {
			handleAiMachineFetch(filters);
		}
	};

	const handleOpenBills = (item) => {
		window.open(`${urls.EXTENSION}${urls.BILLS}?grnId=${item?.id}`);
	};

	const statusChildTransaction = (childTransactionRecord) => {
		if (childTransactionRecord?.length === 0) {
			return false;
		}
		if (childTransactionRecord?.length > 0) {
			const status = childTransactionRecord?.some((ele) => {
				return ele?.transactionStatus !== 'CANCELLED';
			});
			return status;
		}
		return false;
	};

	const handleGeneratebill = (grnId, poId) => {
		const url = `${urls.EXTENSION}${urls.BILLS}/add?grnId=${grnId}&poId=${poId}`;
		history.push(url);
	};

	const SPECIAL_ITEMS = {
		'Grn Number': (id, item) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>
				{item} 
				</div>
			);
		},
		'Vendor Name': (id, item) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>{item}</div>
			);
		},
		'Grn Closed At': (id, item) => {
			if (!item) return '-';
			try {
				const date = new Date(item);
				if (isNaN(date.getTime())) return '-'; // Check if date is valid
				return (
					<div className='text-left text-[12px] text-nowrap'>
						{moment(date).format('YYYY-MM-DD HH:mm:ss')}
						{/* {formatDateOneLiner(date)} */}
					</div>
				);
			} catch (error) {
				return '-';
			}
		},
		// 'GRN Start Time': (id, item) => {
		// 	if (!item) return '-';
		// 	try {
		// 		const date = new Date(item);
		// 		if (isNaN(date.getTime())) return '-'; // Check if date is valid
		// 		return (
		// 			<div className='text-left text-[12px] text-nowrap'>
		// 				{date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
		// 			</div>
		// 		);
		// 	} catch (error) {
		// 		return '-';
		// 	}
		// },
		'Po Id': (id, item) => {
			return (
				<div className='text-left text-[12px] text-nowrap'>{item}</div>
			);
		},
		'order Completion': (id, item) => {
			const items = grnList?.find((data) => data?.id === id)?.items;
			const fulfilled = items?.reduce(
				(acc, item) => acc + (item?.fulfilled || 0),
				0
			);
			const qty = items?.reduce((acc, item) => acc + (item?.qty || 0), 0);
			const percentage = qty ? ((fulfilled / qty) * 100).toFixed(2) : 0;
			const adjustmentQty = grnList?.find((item) => item?.id == id)?.extraData?.adjustments
			const isAdjustment = Object?.values(adjustmentQty ?? {})?.length > 0;
			return (
				<div className='text-left flex gap-2 align-center text-[12px] text-nowrap'>
					{percentage}%
					{isAdjustment ? <Tooltip title='Adjustment Done'> <Calculator className='text-orange-500' size={16} /></Tooltip> : null}
				</div>
			);
		},
		'Grn Status': (id, _) => {
			const items = grnList?.find((ele) => ele?.id === id);
			const transactionStatus = items?.transactionStatus;
			const status = transactionStatus;
			return (
				<div className='flex w-full justify-start items-center'>
					{['LABELLING', 'VERIFICATION'].includes(status) ? (
						<div className='text-[#EA580C] bg-[#FFF7ED] py-2 px-2 rounded-md w-[100px] text-[12px]'>In Progress</div>
					) : ['ABANDONED'].includes(status) ? (
						<div className='text-[#5e5957] bg-[#f5f3f3] py-2 px-2 rounded-md w-[100px] text-[12px]'>Abandoned</div>
					) : ['FULFILLED'].includes(status) ? (
						<div className='text-[#15803D] bg-[#DCFCE7] py-2 px-2 rounded-md w-[100px] text-[12px]'>Fulfilled</div>
					) : ['CANCELLED'].includes(status) && (
						<div className='text-red-400 bg-red-100 py-2 px-2 rounded-md w-[100px] text-[12px]'>PO Cancelled</div>
					)}
				</div>
			);
		},
		'Bill Status': (id, _) => {
			const items = grnList?.find((ele) => ele?.id === id);
			const childTransactionRecord = statusChildTransaction(
				items?.childTransactionRecord
			);
			return (
				<div className='flex w-full justify-start items-center'>
					{childTransactionRecord ? (
						<div className='text-[#3B82F6] bg-[#DBEAFE] py-2 px-2 rounded-md w-[100px] text-[12px]'>Billed</div>
					) : (
						<div className='w-[100px] text-[12px]'>Unbilled</div>
					)
					}
				</div>
			)
		},
		'View Docs': (id, item) => {
			const items = grnList?.find((ele) => ele?.id === id);
			const childTransactionRecord = statusChildTransaction(
				items?.childTransactionRecord
			);
			return (
				<div
					className='flex flex-col gap-3 justify-center items-center'
					onClick={(e) => e.stopPropagation()}
				>
					{items?.transactionStatus !== 'LABELLING' && items?.transactionStatus !== 'VERIFICATION' && (
						childTransactionRecord ?
							(
								<Chip
									size='small'
									className=' w-[120px] p-[15px] font-bold text-[12px]'
									label='Bills'
									onClick={(e) => {
										e.stopPropagation();
										handleOpenBills(items);
									}}
								/>
							) : (
								level !== 1 &&
								<Chip
									size='small'
									className='w-[120px] p-[15px] font-bold whitespace-normal break-words text-[12px]'
									label='Generate Bill'
									onClick={(e) => {
										e.stopPropagation();
										handleGeneratebill(items?.id, items?.orderId);
									}}
								/>
							))}
				</div>
			);
		},
	};

	const handleTabChange = (value) => {
		setActiveTab(value);
		if (value === 'aiMachineLogs') {
			handleAiMachineFetch(filters);
		} else {
			handleGrnListFetch(filters);
		}
	};

	const handleExport = async (filters) => {
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'loading...',
		});
		try {
			const response = await inventoryAnalyticsServices.exportGrnRecord({
				req: {
					data: {
						filters: {
							fromStoreId:
								Number(navSelectedStore?.value?.id) === -999
									? null
									: navSelectedStore?.value?.id,
							vendors: filters?.vendors?.id,
							storeId: filters?.store?.id,
							dateRangeFilter: {
								timeType: 'closedAt',
								from: formatDate(
									filters?.dateRange?.from ?? new Date()
								),
								to: formatDate(
									filters?.dateRange?.to ?? new Date()
								),
							},
							productId: filters?.product?.id ?? null,
							productCategoryId:
								filters?.productCategory?.id ?? null,
							grnStatus: filters?.type,
							billStatus: filters?.paymentType,
						},
						type: 'GRN',
						children: true,
						allowAbandoned: true,
						export: true,
					},
				}
			});
			if (response?.status === 200) {
				const exportFileName = `GRN Logs${moment(filters?.dateRange?.from).format('DD-MM-YYYY')}_${moment(filters?.dateRange?.to).format('DD-MM-YYYY')}.csv`;
				handleResponseStreamDownload(response, exportFileName);
				notificationServices.generateNotification({
					type: 'success',
					message: 'Data exported successfully',
					config: {
						id: notificationId,
					},
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: {
						id: notificationId,
					}
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
				config: {
					id: notificationId,
				}
			});
		}
	};

	const filtersInfo = {
		header: {
			date: false,
			store: false,
			statusAndTypes: activeTab === 'grnLogs' ? false : true,
			product: false,
		},
		dateRangeOnly: {
			text: 'Date Range (GRN closed) ',
			show: true,
		},
		product: {
			show: true,
			singleSelect: true,
		},
		vendor: {
			show: true,
		},
		productCategory: {
			show: true,
			singleSelect: true,
		},
		store: {
			show: true,
		},
		type: {
			text: 'Select Order Status',
			show: true,
			list: [
				{
					type: 'ABANDONED',
					label: 'Abandoned',
				},
				{
					type: 'FULFILLED',
					label: 'Fulfilled',
				},
				{
					type: 'IN_PROGRESS',
					label: 'In Progress',
				},
				// {
				// 	type: 'CANCELLED',
				// 	label: 'Cancelled',
				// },
				// {
				// 	type: 'PENDING',
				// 	label: 'Pending',
				// }
			],
		},
		paymentType: {
			text: 'Select Bill Status',
			show: true,
			placeholder: 'Select Bill Status',
			list: [
				{
					type: 'BILLED',
					label: 'Billed',
				},
				{
					type: 'UNBILLED',
					label: 'Unbilled',
				},
			],
		}
	};

	return (
		<div className={styles.root}>
			<POItemsModal />
			<ImagesFinder
				onSubmit={handleListFetch}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
				tabType={activeTab}
				initialState={{ orderType: orderType ?? 'grnLogs' }}
			/>
			<p className='text-[16px] font-bold text-start ml-[1rem] mt-[12px]'>
				GRN Logs
			</p>
			<div className='flex flex-col p-2'>
				<div className='flex items-center justify-between w-full'>
					<GlobalSearch
						dropDownOptions={dropDownItems}
						setSelectedValue={setSearch}
						placeholderText='Search ...'
					/>
					<Button
						onClick={(e) => {
							dispatch(
								drawerActions?.toggleFiltersDrawer(true, {
									handleDataExport: (filters) => {
										handleExport(filters);
									}
								})
							);
						}}
						className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='text-nowrap'>Filter & Export</span>
						<Filter className='size-4' />
					</Button>
				</div>
			</div>
			<div className='flex items-center justify-between w-full'>
				<Tab
					tabValue={activeTab}
					handleTabChange={handleTabChange}
					tabList={tabList}
				/>
				{filtersInfoChip(filtersInfo, filters)}
			</div>
			<div className='overflow-auto' style={{ maxHeight: '65vh' }}>
				{activeTab === 'grnLogs' && (
					<GrnTable
						data={generateData()}
						colMap={COLMAP}
						special={SPECIAL_COLUMNS}
						specialMappings={SPECIAL_ITEMS}
						tableType='grnLogs'
						location={location}
					/>
				)}
				{activeTab === 'aiMachineLogs' && (
					<GrnTable
						data={generateData()}
						colMap={aiMachineColMap}
						special={aiMachineSpecialColumns}
						specialMappings={aiMachineSpecialColumnsMappings}
						tableType='aiMachineLogs'
						location={location}
					/>
				)}
			</div>
		</div>
	);
}
const mapStateToProps = (state) => {
	const { userPermissions, navState } = state.navigation;
	const { userList } = state?.auth;
	const stores = state?.form?.STORES?.data?.LIST;
	const { LIST: vendorsList } = state.form.ALL_VENDORS.data;
	const { query: searchQuery, searchBy } =
		state.analytics.AI_PRODUCTION_ANALYSIS.SEARCH_DATA;
	return {
		userPermissions,
		navState,
		userList,
		stores,
		vendorsList,
		searchQuery,
		searchBy,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleListModal,
	togglePOItemsModal: modalActions.togglePOItemsModal,
	togglePaymentModal: modalActions.togglePaymentModal,
	fetchUserList: authActions?.fetchUserList,
	fetchStoresList: formActions.gateway,
	fetchAllVendors: formActions.gateway,
};

export default connect(mapStateToProps, mapDispatchToProps)(GRNsPage);
